<ion-list class="menu-options sidebar allow-scroll-bar" [class.sidebar-expanded]="isExpanded">
  <ng-container *ngFor="let option of sideBarOptions; trackBy: trackByOptionId">
    <ion-item class="menu-item" [class.itemSelected]="option.selected" (click)="onClickMenuOption(option)"
      button="true" [detail]="false"
      [attr.aria-label]="option.ariaLabel || option.displayName" [attr.aria-current]="option.selected ? 'page' : null"
      [tooltip]="isExpanded ? '' : option.displayName" (events)="onTooltipVisibilityChange()">
      <div class="container">
        <ng-container *ngIf="!option.iconPath.endsWith('.svg'); else svgIcon">
          <img class="menu-icon" alt="" [src]="getIconPath(option)" />
        </ng-container>
        <ng-template #svgIcon>
          <ion-icon class="menu-icon" aria-hidden="true" [attr.data-nav-domain]="option.iconDomain" [src]="getIconPath(option)"></ion-icon>
        </ng-template>
        <span *ngIf="isExpanded" class="menu-label">{{ option.displayName }}</span>
      </div>
    </ion-item>
  </ng-container>
</ion-list>
